import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { findIndex, isNil } from 'lodash';
import * as classnames from 'classnames';
import {
  SINGLE_PROJECT_BASIC_SECTION,
  SINGLE_PROJECT_DATA_EXTRACTION_SECTION,
  SINGLE_PROJECT_EXPERIMENTAL_SECTION
} from '../data/projectActions';

const Header = props => {
  /**
   * Single Project Menu Structure
   * @type {*[]}
   */

  const projectId = props.project ? props.project.id : null;

  const singleProjectMenu = [
    {
      label: 'Preparation',
      width: 6,
      subMenu: [
        {
          link: `/projects/${projectId}`,
          label: 'Basic Project Information',
          slug: SINGLE_PROJECT_BASIC_SECTION
        },
        {
          link: `/projects/${projectId}/experimental-design`,
          label: 'Experimental Design',
          slug: SINGLE_PROJECT_EXPERIMENTAL_SECTION,
          extraClasses: classnames({
            experimentalDesign: true,
            locked: props.project && props.project.template_locked
          })
        }
      ]
    },
    {
      label: 'Execution',
      width: 10,
      subMenu: [
        /* {
                    link: `/projects/${projectId}/booking`,
                    label: "Booking",
                    slug: SINGLE_PROJECT_BOOKING_SECTION
                }, */
        {
          link: `/projects/${projectId}/file-import`,
          label: 'File Import',
          slug: SINGLE_PROJECT_DATA_EXTRACTION_SECTION,
          enabled: props.project && props.project.template_locked
        },
        {
          link: `/analysis/${projectId}`,
          label: 'Analysis',
          enabled: props.project && props.project.template_locked
        }

        /* {
                    link: null,
                    label: "Post-Processing",
                    slug: SINGLE_PROJECT_POST_PROCESSING_SECTION
                } */
      ]
    }
    /* {
            label: "Documentation",
            width: 4,
            subMenu: [
                {
                    link: null,
                    label: "Project History",
                    slug: SINGLE_PROJECT_HISTORY_SECTION
                },
                {
                    link: null,
                    label: "Documents",
                    slug: SINGLE_PROJECT_DOCUMENTS_SECTION
                }
            ]
        } */
  ];

  const headerRows = singleProjectMenu.map((menu, i) => {
    const isSubMenuActive =
      findIndex(menu.subMenu, subMenu => {
        return subMenu.slug === props.section;
      }) >= 0;

    const extraClasses = menu.extraClasses || '';

    const classes = classnames(extraClasses, {
      'sub-menu__title--active': isSubMenuActive,
      'sub-menu__title': true,
      [`sub-menu__title--step${i + 1}`]: true
    });

    return (
      <Grid.Column key={menu.label} className={classes} width={menu.width}>
        {menu.label}
      </Grid.Column>
    );
  });

  const subMenuCols = singleProjectMenu.map((menu, i) => {
    const columns = menu.subMenu.map((subMenu, k) => {
      const extraClasses = subMenu.extraClasses || '';

      const classes = classnames(extraClasses, {
        'sub-menu__sub-title--active': subMenu.slug === props.section,
        'sub-menu__sub-title': true
      });

      if (isNil(subMenu.link)) {
        return (
          <Grid.Column key={subMenu.label} className={classes}>
            {subMenu.label}
          </Grid.Column>
        );
      }

      let link = (
        <Link
          onClick={subMenu.clickHandler}
          to={{ pathname: subMenu.link, state: { fromApp: true } }}
        >
          {subMenu.label}
        </Link>
      );
      if (!isNil(subMenu.enabled) && !subMenu.enabled) {
        link = <span>{subMenu.label}</span>;
      }
      return (
        <Grid.Column key={subMenu.label} className={classes}>
          {link}
        </Grid.Column>
      );
    });

    return (
      <Grid.Column
        key={`${menu.label}-section`}
        className="sub-menu__sub-section sub-menu__sub-section--no-padding"
        width={menu.width}
      >
        <Grid columns={columns.length} celled className="sub-menu__sub-section-container">
          {columns}
        </Grid>
      </Grid.Column>
    );
  });

  return (
    <div className="sub-menu">
      <Grid celled columns={3}>
        <Grid.Row>{headerRows}</Grid.Row>
      </Grid>

      <Grid celled>
        <Grid.Row>{subMenuCols}</Grid.Row>
      </Grid>
    </div>
  );
};

Header.propTypes = {
  project: PropTypes.object, // eslint-disable-line react/require-default-props, react/forbid-prop-types
  section: PropTypes.string // eslint-disable-line react/require-default-props
};

export default Header;



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/Header.js